/**
* Location based popup
*/
class locationPopup extends HTMLElement {
    constructor() {
        super();
        this.checkForInitial = false;
        if(document.referrer == 'https://shopify.com/'){
        // Utility.removeCookie('locationID')
        }

        if(Utility.getCookie('customer_location') != document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase()){
            Utility.removeCookie('locationID');
            Utility.removeCookie('cif_customerLocationData');
        }

        // Instead of below JSOn we will use API
        //let locationJSONEle = document.querySelector('[data-locationScriptJSON]');
        this.locationPopup =  this.querySelector('.pdp-modal-content');
        this.closeLocationPopupbtn = this.querySelector('[data-close-location]')

        this.loadLocation();
        // console.log('locationID',Utility.getCookie('locationID'));
        // if(document.querySelector('[data-currentSelectedAddress]')){
        //     let getLocAttr = document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentlocations');
        //     console.log('getLocAttr',getLocAttr);
        //     if(getLocAttr != null){
        //         if(Number(Utility.getCookie('warehouseID')) != Number(getLocAttr)){
                    
        //         }
        //     }
        // }
        if(Utility.getCookie('locationID') == ''){
            // console.log('11',Utility.getCookie('websiteType'));
            // document.querySelector('.site-loader').classList.add('loading');
            this.checkForInitial = true;
            // this.openPopup();
            // this.closeLocationPopupbtn.classList.add('d-none');
            // this.locationPopup.style = "margin-top:30px;"
        }else{
            // this.closeLocationPopupbtn.classList.remove('d-none');
            // document.querySelector('body').classList.remove('open-location');
            // var getSelectOptions = document.querySelectorAll("[datalocation-select] option");
            // getSelectOptions.forEach(option => {
            //     if(option.getAttribute('data-location-id') == Utility.getCookie('locationID')){
            //         document.querySelector('[data-location-name]').innerHTML = option.text;
            //     }
            // });
            // document.querySelector('[data-location-dropdown]').classList.remove('d-none');
        }

        if(document.querySelector('[datalocation-select]')){
            document.querySelector('[datalocation-select]').addEventListener('change', this.selectChange.bind(this));
        }
    //   if(document.querySelector('[data-location-dropdown]')){
    //   document.querySelector('[data-location-dropdown]').addEventListener('click', this.openPopup.bind(this));
    //   }

      
    }

    getPreviousPageUrl() {
        history.back();
        return location.href;
    }

    loadLocation(){
        fetch('https://shopifyapi2.jinny.com/api/get-locations',{
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).
        then(response => {
            return response.json();
          }).then(response => {
            let locationJSON = (response);
            // console.log('locationJSON',locationJSON);

            /* START:: Added restriction for not match URL or site with selected Location */
            if(Utility.getCookie('locationID') != ''){
                locationJSON.locations.forEach(function(data, index) {
                    if(parseInt(data.location_id) == parseInt(Utility.getCookie('locationID'))){
                        let dataurl = `https://${window.globalVariables.domain}${data.redirect_link}` 
                        if(dataurl != Utility.getCookie('websiteURL')){
                            // window.location.href = dataurl
                            // console.log('data url', dataurl, Utility.getCookie('websiteURL'))
                        }
                        // console.log('data.location_id',data.location_id)
                    }
                });
            }
            // console.log('locationJSON',locationJSON)

            this.fillPopup(locationJSON)
          }).catch((e) => {
              console.error(e);
              Rollbar.error(`File: component-location-popup.js, getting error on loadLocation: ${e}`);
          }).finally(() => {
              // Cart HTML fetch done
          });

        
    }

    fetchLocation(){
        fetch("https://jinny-beauty-backend.localhost/api/get-locations", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(requestData),
            }).then((data) =>{
                // console.log('data',data);
            });
    }

    openPopup(){
        document.getElementById('LocationPopup').querySelector('.modal').classList.add('open');
        document.querySelector('body').classList.add('open-location')
        siteOverlay.prototype.showOverlay();
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    fillPopup(jsonData) {
        
        let getCustomerTag = document.querySelector('[data-cust-tags]').getAttribute('data-cust-tags');
        let getCurrentSelectedLocation = document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase();

        // console.log('getCurrentSelectedLocation==>',getCurrentSelectedLocation)

        if(getCurrentSelectedLocation != ''){

        let getCustomerTags = getCustomerTag.split(',');
        let cureentLocations = document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentlocations').split(',');
        // let allLocations = window.globalVariables.location_address;

        let arrayLocation = [];
        // console.log(allLocations,'allLocations')
        getCustomerTags.forEach(function(data1, index1) {
            if(data1 != ''){
            let location = data1.replace('location_','');
            cureentLocations.forEach(data2 => {
                    // console.log('data1',data1,'data2',data2);
                    if(parseInt(location) == parseInt(data2)){
                        // if(((data2.ship_address).toLowerCase()).indexOf((getCurrentSelectedLocation)) > -1){
                            arrayLocation.push(parseInt(data2));
                        // }
                    }
                });
            }
        });
        // console.log('arrayLocation',arrayLocation)
        // getCustomerTags.forEach(function(data1, index1) {
        //     if(data1 != ''){
        //     let location = data1.replace('location_','');
        //         allLocations.forEach(data2 => {
                   
        //             if(parseInt(location) == parseInt(data2.location_id)){
        //                 if(((data2.ship_address).toLowerCase()).indexOf((getCurrentSelectedLocation)) > -1){
        //                     arrayLocation.push(parseInt(data2.location_id));
        //                 }
        //             }
        //         });
        //     }
        // });
        // console.log('arrayLocation',arrayLocation)
        var finalLocationArray = arrayLocation.filter((value, index, array) => array.indexOf(value) === index);
        jsonData.locations.forEach(function(data, index) {
            console.log('data',data);
            finalLocationArray.forEach(function(data1, index1) {
                if(data1 != ''){
                    // let locationID = data1.replace('location_','');
                    
                    if(Number(data.warehouse_id) == Number(data1)){
                        
                    // if(getCurrentSelectedLocation.search((data.warehouse).toLowerCase()) > -1){
                        var optionEle = document.createElement("option");
                        optionEle.text = data.name;
                        optionEle.value = data.redirect_link;
                        optionEle.setAttribute('data-location-id',Number(data.location_id));
                        optionEle.setAttribute('data-warehouse-id',Number(data.warehouse_id));
                        optionEle.setAttribute('class','product-custom-option');
                        var select = document.querySelector("[datalocation-select]");
                        select.appendChild(optionEle);

                        if(Number(Utility.getCookie('locationID')) != Number(data.location_id)){
                            console.log('hereeee');
                            // document.querySelector('.site-loader').classList.add('loading');
                            Utility.removeCookie('cif_customerLocationData');
                            Utility.setCookie('locationID', Number(data.location_id), 7);
                            Utility.setCookie('warehouseID', Number(data.warehouse_id), 7);
                            Utility.setCookie('customer_location',document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase());
                            Utility.setCookie('popupLocation', data.name, 7);
    
                            console.log('data.redirect_link',data.redirect_link);
            
                            fetch('/cart/clear.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Requested-With': 'XMLHttpRequest'
                                }
                                })
                                .then(response => {
                                if (response.ok) {
                                    console.log(response,'Cart cleared successfully.');
                                    let cartElement = document.querySelector('cart-form'); 
                                    cartElement.getCartData('updateCart');
                                //   window.location.href = data.redirect_link;
                                } else {
                                    console.error('Failed to clear the cart:', response.statusText);
                                }
                                })
                                .catch(error => {
                                console.error('Error clearing the cart:', error);
                                });
                        }

                    // }
                    }
                }
            });
            if(parseInt(Utility.getCookie('locationID')) === parseInt(data.location_id)){
                document.querySelector('[data-location-id="' + data.location_id + '"]').selected = true;
                var getSelect = document.querySelector("[datalocation-select]");
                var text = getSelect.options[getSelect.selectedIndex].text;
                document.querySelector('[data-location-name]').innerHTML = text;
                document.querySelector('[data-location-dropdown]').classList.remove('d-none');
            }
        });
        
        var selectOptions = document.querySelectorAll("[datalocation-select] option")
        if(selectOptions.length == 1){
            
            this.locationPopup.style = "margin-top:30px;"
            this.locationPopup.innerHTML = `<div class="text-center">There are no warehouse available at your shipping location. <br><br><a href="https://shopify.com/86571778347/account/locations">Please select a different shipping location </a></div>`;
            this.openPopup();
            this.closeLocationPopupbtn.classList.add('d-none');
            this.locationPopup.style = "margin-top:30px;"
        }
        }else{
            this.locationPopup.style = "margin-top:30px;"
            this.locationPopup.innerHTML = `<div class="text-center">There are no warehouse available at your shipping location. <br><br><a href="https://shopify.com/86571778347/account/locations">Please select a different shipping location </a></div>`;
            this.openPopup();
            this.closeLocationPopupbtn.classList.add('d-none');
            this.locationPopup.style = "margin-top:30px;"
        }
    }

    selectChange(event){

        // console.log('this.checkForInitial',this.checkForInitial)

        let old_getLocation = Utility.getCookie('locationID');
        let old_getwarehouseId = Utility.getCookie('warehouseID');
        let old_customer_location =  Utility.getCookie('customer_location');
        let old_popupLocation =  Utility.getCookie('popupLocation');
        let old_websiteType = Utility.getCookie('websiteType');

        let selectedOption = event.currentTarget.options[event.currentTarget.selectedIndex].value;
        let getLocation = event.currentTarget.options[event.currentTarget.selectedIndex].getAttribute('data-location-id');
        let getwarehouseId = event.currentTarget.options[event.currentTarget.selectedIndex].getAttribute('data-warehouse-id');

        Utility.removeCookie('cif_customerLocationData');
        Utility.setCookie('locationID', getLocation, 7);
        Utility.setCookie('warehouseID', getwarehouseId, 7);
        Utility.setCookie('customer_location',document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase());
        Utility.setCookie('popupLocation', event.currentTarget.options[event.currentTarget.selectedIndex].text, 7);


        // console.log('22',Utility.getCookie('websiteType'),Utility.getCookie(`savecart_${Utility.getCookie('websiteType')}`))
            var xhttp = new XMLHttpRequest();
            xhttp.open("POST", "/cart/clear.js", true);
            xhttp.send();
            setTimeout(function(){
                // console.log('22==>',Utility.getCookie('websiteType'),Utility.getCookie(`savecart_${Utility.getCookie('websiteType')}`))
                window.location.href = selectedOption;
            },1000)

        // let checkFlagInside 
        // if(Utility.getCookie('popupLocation') != event.currentTarget.options[event.currentTarget.selectedIndex].text){
        //     if(window.globalVariables.cart.item_count == 0){
        //         window.location.href = selectedOption;
        //     }
        //     if(this.checkForInitial == false){
        //         if(window.globalVariables.cart.item_count > 0){
        //             document.querySelector('#LocationPopup .modal').classList.remove('open');
        //             siteOverlay.prototype.hideOverlay();
        //             setTimeout(function(){
        //                 document.querySelector('#PopupModal-locationChange .modal').classList.add('open');
        //                 siteOverlay.prototype.showOverlay();
        //             },200) 
        //         }
        //     }else{
        //         window.location.href = selectedOption;
        //     }
        //     // var xhttp = new XMLHttpRequest();
        //     // xhttp.open("POST", "/cart/clear.js", true);
        //     // xhttp.send();
        // }else{
        //     if(window.globalVariables.cart.item_count > 0){
        //         if(this.checkForInitial == false){
        //         // console.log('checkmm')
        //             document.querySelector('#LocationPopup .modal').classList.remove('open');
        //             siteOverlay.prototype.hideOverlay();
        //             setTimeout(function(){
        //                 document.querySelector('#PopupModal-locationChange .modal').classList.add('open');
        //                 siteOverlay.prototype.showOverlay();
        //             },200)
        //         }else{
        //             window.location.href = selectedOption;
        //         }
        //     }else{
        //         window.location.href = selectedOption;
        //     }
        // }
        

        
        // if(Utility.getCookie('popupLocation') != event.currentTarget.options[event.currentTarget.selectedIndex].text){
        //     console.log('dsdkjshkhdkshdkshdkdshkshdksdhk')
        //     if(window.globalVariables.cart.item_count == 0){
        //         window.location.href = selectedOption;
        //     }
        // }else{
        //     if(window.globalVariables.cart.item_count > 0){
        //         if(this.checkForInitial == false){
        //         // console.log('checkmm')
        //             document.querySelector('#LocationPopup .modal').classList.remove('open');
        //             siteOverlay.prototype.hideOverlay();
        //             setTimeout(function(){
        //                 document.querySelector('#PopupModal-locationChange .modal').classList.add('open');
        //                 siteOverlay.prototype.showOverlay();
        //             },200)
        //         }else{
        //             window.location.href = selectedOption;
        //         }
        //     }else{
        //         window.location.href = selectedOption;
        //     }
        // }
        // document.querySelector('[data-locationchange-yes]').addEventListener('click', (event) => {
        //     console.log('22',Utility.getCookie('websiteType'),Utility.getCookie(`savecart_${Utility.getCookie('websiteType')}`))
        //     var xhttp = new XMLHttpRequest();
        //     xhttp.open("POST", "/cart/clear.js", true);
        //     xhttp.send();
        //     setTimeout(function(){
        //         console.log('22==>',Utility.getCookie('websiteType'),Utility.getCookie(`savecart_${Utility.getCookie('websiteType')}`))
        //         window.location.href = selectedOption;
        //     },1000)
        // });
        // document.querySelector('[data-locationchange-no]').addEventListener('click', (event) => {
        //     Utility.setCookie('locationID', old_getLocation);
        //     Utility.setCookie('warehouseID', old_getwarehouseId);
        //     Utility.setCookie('customer_location',old_customer_location);
        //     Utility.setCookie('popupLocation', old_popupLocation);
        //      window.location.href = Utility.getCookie('websiteURL');
        // });
    }
  
}
customElements.define("location-popup", locationPopup);
